<template>
  <div class="fatherBox">
    <div>
      <van-field class="ipt" v-model="value" :placeholder="$18nText(166)" />
      <p>{{ $18nText(167) }}</p>
      <van-button :disabled="onOFF" @click="editUserName" class="bnt">{{
        $18nText(87)
      }}</van-button>
    </div>
  </div>
</template>
<script>
import { updateUserInfo } from '@/api/user';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      value: '',
      onOFF: true
    };
  },
  watch: {
    value(newData) {
      if (newData == '') {
        this.onOFF = true;
      } else {
        this.onOFF = false;
      }
    }
  },
  computed: {
    ...mapGetters(['nickName'])
  },
  activated() {
    this.value = this.$route.query.nickName || '';
  },
  methods: {
    editUserName() {
      updateUserInfo({ nickName: this.value }).then(res => {
        if (res.code == 200) {
          this.$toast(this.$18nText(164));
          this.$winOpen({ path: 'clearPage' });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.fatherBox {
  background: #fff;
  .ipt {
    font-size: 0.24rem;
    width: 6rem;
    border-bottom: 1px solid #707070;
    margin: 0.8rem auto 0.2rem;
    /deep/ .van-field__control {
      text-align: center;
    }
  }
  p {
    font-size: 0.2rem;
    font-weight: 400;
    line-height: 0.6rem;
    color: rgba(43, 47, 56, 1);
    text-align: center;
    color: #2b2f38;
    margin-bottom: 0.9rem;
  }
  .bnt {
    display: block;
    width: 6.4rem;
    height: 0.88rem;
    line-height: 0.88rem;
    border: 1px solid rgba(43, 47, 56, 1);
    border-radius: 1rem;
    margin: 0 auto 0.4rem;
    font-size: 0.24rem;
    font-weight: 400;
    color: rgba(43, 47, 56, 1);
    letter-spacing: 0.1rem;
  }
}
</style>
